import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ISpecialistCatalogListing } from '../types/demand/specialistListing';
import { GetReturnType } from '../types/getReturnType';

export interface IRealtorsState {
  specialists: {
    [key: string]: ISpecialistCatalogListing;
  };
  currentRealtor: ISpecialistCatalogListing | null | undefined;
}

export const realtorsInitialState: IRealtorsState = {
  specialists: {},
  currentRealtor: null,
};

// Выбранные из списка риелторы
export const realtorsSlice = createSlice({
  name: 'realtors',
  initialState: realtorsInitialState,
  reducers: {
    addSpecialist(state, { payload }: PayloadAction<ISpecialistCatalogListing>) {
      state.specialists[String(payload.id) as string] = payload;
    },
    removeSpecialist(state, { payload }: PayloadAction<string>) {
      delete state.specialists[payload];
    },
    setCurrentRealtor(state, { payload }: PayloadAction<ISpecialistCatalogListing>) {
      state.currentRealtor = payload;
    },
    resetCurrentRealtor(state) {
      state.currentRealtor = null;
    },
  },
});

export type TRealtorsSlice = GetReturnType<typeof realtorsSlice.actions>;

export const { addSpecialist, removeSpecialist, resetCurrentRealtor, setCurrentRealtor } = realtorsSlice.actions;
